import React, {useState} from "react"
import Paragraph from "antd/lib/typography/Paragraph"
import {changeToDecimal} from "../../../../../../../util"
import {message, Table} from "antd"
import {getClubMemberTrackBillDetail} from "../../../../../../../api/clubMemberList"
import ClubMemberFindTrackCommodity from "./ClubMemberFindTrackCommodity"
import ClubMemberFindTrackRound from "./ClubMemberFindTrackRound"

const ClubMemberFindTrackBill = ({loading, datasource, total, onPageChange}) => {
    const [isLoading, setIsLoading] = useState(false)
    const [commodityRecord, setCommodityRecord] = useState([])
    const [roundList, setRoundList] = useState([])
    const [price, setPrice] = useState(0)

    const columns = [
        {
            title: '俱乐部名称',
            dataIndex: 'club_name',
            key: 'club_name',
        },
        {
            title: '订单号',
            dataIndex: 'temporary_number',
            key: 'temporary_number',
            render: (text) => (<Paragraph copyable>{text}</Paragraph>)
        },
        {
            title: '流水号',
            dataIndex: 'serial_number',
            key: 'serial_number',
            render: (text) => (<Paragraph copyable>{text}</Paragraph>)
        },
        {
            title: '台名',
            dataIndex: 'table_name',
            key: 'table_name',
        },
        {
            title: '结账时间',
            dataIndex: 'ctime',
            key: 'ctime',
        },
        {
            title: '结账方式',
            dataIndex: 'payment_name',
            key: 'payment_name',
        },
        {
            title: '金额',
            dataIndex: 'price',
            key: 'price',
            render: (text) => {
                return <span>{changeToDecimal(text)}</span>
            },
        },
    ]

    const fetchCommodityRecord = async (sn) => {
        setIsLoading(true)
        await getClubMemberTrackBillDetail(sn).then((res) => {
            setCommodityRecord(res.goodsList)
            setRoundList(res.list)
            setPrice(res.prices)
        }).catch((err) => {
            message.error(err)
        }).finally(() => {
            setIsLoading(false)
        })
    }


    return (
        <div>
            <Table
                columns={columns}
                rowKey={record => record.id}
                dataSource={datasource}
                loading={loading}
                pagination={{
                    total: total,
                    onChange: onPageChange
                }}
                expandable={{
                    onExpand: (_, record) => {
                        fetchCommodityRecord(record.serial_number)
                    },
                    expandedRowRender: () => {
                        return (
                            <div>
                                <div style={{padding: 16}}>付款金额：￥{price}</div>
                                <ClubMemberFindTrackRound loading={isLoading} datasource={roundList}/>
                                <ClubMemberFindTrackCommodity loading={loading} datasource={commodityRecord}/>
                            </div>
                        )
                    },
                    rowExpandable: record => record.serial_number !== null,
                }}
            />
        </div>
    )
}

export default ClubMemberFindTrackBill


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberFind/component/ClubMemberFindTrack/component/ClubMemberFindTrackBill.js